/* Bloc avis Google — extrait de product.json (custom_liquid_a8FfrX) */
/* Anonymisation des noms d'auteurs */
(function(){
  var NEW_NAME = "";
  var selectors = ['[class*="account-name"]','[class*="author-name"]','[class*="reviewer-name"]','[class*="Author"]','[class*="-name"]'];
  function replaceNames(root){
    selectors.forEach(function(sel){
      try {
        root.querySelectorAll(sel).forEach(function(el){
          if(el.children.length === 0 && el.textContent.trim().length > 0 && el.textContent.trim().length < 40){
            if(el.textContent !== NEW_NAME){ el.textContent = NEW_NAME; }
          }
        });
      } catch(e){}
    });
  }
  function init(){
    if(!document.querySelector('[class*="elfsight-app-55f7cda7"]')){ return; }
    replaceNames(document);
    new MutationObserver(function(){ replaceNames(document); }).observe(document.body, {childList:true, subtree:true});
  }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  [1000, 2500, 5000].forEach(function(t){ setTimeout(function(){ replaceNames(document); }, t); });
})();
